import { ListBoxOutlineIcon } from './ListBoxOutlineIcon';

/**
 * author: frankgrinaert
 * id 3EE285E0-8234-4B20-BFD4-B82AEA64EA57
 * name list-box-outline
 * version: 7.0.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/list-box-outline.svg
 * tags
 */
export const FormOutlineIcon = ListBoxOutlineIcon;
export default FormOutlineIcon